module.exports = __webpack_public_path__ + "img/image3.ba92e10e.png";